import React, { Component } from "react";
import { Table } from "reactstrap";
import style from "./Table.module.scss";
import MediaQuery from "react-responsive";

class ResponsiveTable extends Component {
  render() {
    return (
      <MediaQuery minWidth={800}>
        {(matches) => {
          const tbodyChild = getTbodyChild(this.props.children);

          if (tbodyChild == null) {
            return null;
          }

          if (tbodyChild.length == 0) {
            return <Empty text={this.props.emptyText} />;
          }

          return matches ? (
            <Table striped hover responsive size="sm" style={this.props.style || {}}>
              {this.props.children}
            </Table>
          ) : (
            <CardList>{this.props.children}</CardList>
          );
        }}
      </MediaQuery>
    );
  }
}

const getChildren = (e) => e.props.children;

const getTbodyChild = (root) => {
  let tbody;

  React.Children.forEach(root, (child, i) => {
    if (child.type === "tbody") tbody = child;
  });
  return getChildren(tbody);
};

const getCardLines = (elements) => {
  let fstLine = [];
  let sndLine = [];

  const tdCollection = getChildren(elements) || [];

  tdCollection.forEach((td) => {
    const pos = td.props.sm || {};
    const i = pos.i || 1;
    const j = isNaN(pos.j) ? 99 : pos.j;

    if (i == 1) {
      fstLine.insert(j, getChildren(td));
    } else {
      sndLine.insert(j, getChildren(td));
    }
  });

  return {
    first: fstLine,
    second: sndLine,
  };
};

const CardList = (props) => {
  const tbodyChild = getTbodyChild(props.children);

  return (
    <div className={style.mobile} style={props.style || {}}>
      {React.Children.map(tbodyChild, (trowChild, i) => {
        const lines = getCardLines(trowChild);

        return (
          <div className={style.card} key={`card-${i}`}>
            <div>
              {React.Children.map(lines.first, (child, i) => (
                <span className={style.item}>{child}</span>
              ))}
            </div>
            <div>
              {React.Children.map(lines.second, (child, i) => (
                <span className={style.item}>{child}</span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

const Empty = (props) => {
  return (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <h4>{props.text}</h4>
    </div>
  );
};

export default ResponsiveTable;
